// @ts-nocheck
import React from 'react';
import { driverQualificationEnum, drivingLicenseCategories, tractorDrivingLicenseCategories } from '../../lib/enum';
import { Option, Select } from './../ant/Select';
import {
  getLabeledSelectValue,
  toLabeledSelectValue,
} from './labelInValue';
const isTractor = driverQualification => {
  return driverQualification === driverQualificationEnum.tractorMachinistLicense;
};

// Выпадающий список категорий прав
export default ({
  type,
  value,
  onChange,
  driverQualification,
  multiple,
  showAllCategories,
  ...props
}) => {
  let categories;
  if (!showAllCategories) {
    categories = isTractor(driverQualification) ? tractorDrivingLicenseCategories : drivingLicenseCategories;
  } else {
    let tractorCategories = {};
    Object.keys(tractorDrivingLicenseCategories).forEach(el => tractorCategories[el] = `${tractorDrivingLicenseCategories[el]}(Трактор)`);
    categories = {
      ...drivingLicenseCategories,
      ...tractorCategories
    };
  }
  return <Select allowClear mode={multiple ? 'multiple' : 'default'} value={multiple ? (value || []).map(key => toLabeledSelectValue(key, categories[key])) : value} labelInValue={multiple} onChange={value => {
    multiple ? onChange(value.map(getLabeledSelectValue)) : onChange(value);
  }} {...props}>
      {Object.keys(categories).map(category => <Option value={category} key={category}>
          {categories[category]}
        </Option>)}
    </Select>;
};
